import React from "react";
import { useLocation } from "react-router-dom";

function ViewMeal() {
  const location = useLocation();
  const data = location?.state?.data;
  console.log(data ,"data");
  

  if (!data || typeof data !== "object" || !Array.isArray(data.meals)) {
    console.warn("Invalid meal data format:", data);
    return <p className="text-red-500 text-center mt-4">Error: Invalid meal data.</p>;
  }

  return (
    <div className="w-full rounded-xl mt-2 px-5 mx-auto py-3">
      <div className="overflow-x-auto p-4">
        <table className="min-w-full border border-gray-300 shadow-lg">
          <thead className="bg-gray-100 text-left text-sm font-medium">
            <tr>
              <th className="border px-4 py-2">Meal Name</th>
              <th className="border px-4 py-2">Food Name</th>
              <th className="border px-4 py-2">Unit</th>
              <th className="border px-4 py-2">Quantity</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {data.meals.map((meal, mealIndex) =>
              meal.food_items.map((food, foodIndex) => (
                <tr key={`${meal.name}-${food.id}-${foodIndex}`} className="text-sm text-gray-700 hover:bg-gray-50 border-b border-gray-300">
        
                  {foodIndex === 0 && (
                    <td className="border px-4 py-2" rowSpan={meal.food_items.length}>
                      {meal.name}
                    </td>
                  )}
                  <td className="border px-4 py-2">{food.name}</td>
                  <td className="border px-4 py-2">{food.unit}</td>
                  <td className="border px-4 py-2">{food.quantity}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewMeal;
